export default __webpack_public_path__ + "static/media/pagination-arrow-right.29a86e1c.svg";